import { COLORS } from '@/styles/colors';
import { overlayBackground } from '@/styles/common';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { THEME } from '@/styles/theme';
import { poppinsSemiBoldFont, subTitle } from '@/styles/typography';
import styled from 'styled-components';

export const DialogWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${THEME.modal.zIndex};
`;

export const DialogOverlay = styled.div`
  height: 100vh;
  position: fixed;
  inset: 0;
  z-index: ${THEME.modal.zIndex};
  ${overlayBackground};
`;

export const DialogContainer = styled.div`
  padding: 16px;
  height: 100%;
  position: relative;
  z-index: ${THEME.modal.zIndex};
  text-align: center;
  overflow: hidden auto;

  /* Note: this styles allows “vertical-align" to work for ModalBlock. */
  &::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    width: 0;
  }
`;

//Note: we’re using “inline-block” to fix proper vertical scroll for mobiles.
export const DialogBlock = styled.div<{ width?: string }>`
  position: relative;
  text-align: initial;
  vertical-align: middle;
  display: inline-block;
  background: ${COLORS.white};
  box-shadow: 0 2px 20px rgb(63 77 90 / 25%);
  border-radius: 8px;
  will-change: transform;

  &.fade-enter {
    opacity: 0;
    transform: scale(0.9);
  }

  &.fade-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 150ms,
      transform 150ms;
  }

  ${media.mobile`
    width: 100%;
    max-width: none;
  `}

  ${({ width }) =>
    width &&
    `
    width: ${width};
  `}
`;

export const DialogHeaderWrapper = styled.div`
  ${flex({ alignItems: 'center', justifyContent: 'space-between' })};
  border-bottom: 1px solid ${COLORS.grey[300]};
  gap: 12px;
  padding: 20px 30px;
`;

export const DialogHeader = styled.div`
  ${subTitle};
  ${poppinsSemiBoldFont};
`;

export const DialogContent = styled.div`
  padding: 20px 30px 30px;
`;

export const DialogClose = styled.div`
  border: 1px solid ${COLORS.grey[400]};
  font-size: 16px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: border 0.2s;

  &:hover {
    border: 1px solid ${COLORS.grey[350]};
  }
`;

export const DialogButtons = styled.div<{ justifyContent?: string }>`
  width: 100%;
  margin-top: 20px;
  gap: 20px;
  ${({ justifyContent }) => flex({ alignItems: 'center', justifyContent: justifyContent ?? 'flex-end' })};

  ${media.mobile`
    ${flex({ alignItems: 'center', justifyContent: 'center', flexDirection: 'column-reverse' })};
  `}
`;
